import { useOrder } from './orderContext';
import { useAuth } from '../../../../contexts/auth-context';
import { OrderChat } from '../../../../components/chat/OrderChat';
import { getOrderChatMessages, sendOrderChatMessage } from '../../models';
import { trackEvent } from '../../../../utils/track-event';

export const OrderChatPage = () => {
  const { order } = useOrder();
  const { me } = useAuth();

  return (
    <div className="card overflow-hidden">
      <OrderChat
        orderId={order.id}
        fetchMessages={getOrderChatMessages}
        sendMessage={async (orderId, content) => {
          const res = await sendOrderChatMessage(orderId, content);
          trackEvent('order_chat_message_sent', { order_id: orderId });
          return res;
        }}
        currentUserId={me.id}
      />
    </div>
  );
};
